/**
 * The "Accept terms" checkbox lives in the per-tenant SummaryView (shared
 * Checkbox renders it as an input with id="tosAgreed"). The Manage Kits overlay
 * is mounted separately (KitManageOverlay at the app root), so it reads/highlights
 * the checkbox through the DOM rather than via shared state.
 */
export const TOS_INPUT_ID = 'tosAgreed';
const HIGHLIGHT_MS = 2600;

const getTosInput = (): HTMLInputElement | null => document.getElementById(TOS_INPUT_ID) as HTMLInputElement | null;

/**
 * Whether the terms checkbox is accepted. Returns true when there is no checkbox
 * on the page (nothing to gate).
 */
export const isTosAccepted = (): boolean => {
  const el = getTosInput();
  return el ? el.checked : true;
};

/** Scroll the terms checkbox into view and flash an outline to flag it. */
export const highlightTos = (): void => {
  const input = getTosInput();
  if (!input) return;
  const target = (input.closest('.common-components-Checkbox__wrapper') as HTMLElement | null) ?? input;
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  target.style.transition = 'box-shadow 0.2s ease';
  target.style.boxShadow = '0 0 0 2px var(--color-accent, #ed071b)';
  target.style.borderRadius = '6px';
  window.setTimeout(() => { target.style.boxShadow = ''; }, HIGHLIGHT_MS);
};
